export enum StepFunctionPanelToggleButtonKey {
  ExpandAll = 'expand-all',
  CollapseAll = 'collapse-all'
}
